
        var result = require("!!../../../node_modules/css-loader/index.js!./calendar.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./src/app/calendar/calendar.component.css
// module id = 484
// module chunks = 2